import { AUDITED_TYPE_CONSOLIDATED, AUDITED_TYPE_STANDALONE } from '../../../../utils/constants/commonConstants';

/**
 * Derives the default audited type (Consolidated / Standalone) from latest FY values.
 * - Both null → null
 * - Only one non-null → that one
 * - Both non-null, standaloneFY > consolidatedFY → Standalone
 * - Otherwise → Consolidated (tie and all other cases favour Consolidated per spec)
 */
export function deriveAuditedType(consolidatedFY: number | null, standaloneFY: number | null): string | null {
    if (consolidatedFY === null && standaloneFY === null) return null;
    if (consolidatedFY === null) return AUDITED_TYPE_STANDALONE;
    if (standaloneFY === null) return AUDITED_TYPE_CONSOLIDATED;
    return standaloneFY > consolidatedFY ? AUDITED_TYPE_STANDALONE : AUDITED_TYPE_CONSOLIDATED;
}
